/*
 *
 * Login selectors
 *
 */

import { createSelector } from 'reselect';
import { LoginState, initialState } from './reducer';

const selectLoginDomain = (state: any) => state.login || initialState;

const makeSelectLogin = (key: keyof LoginState) =>
  createSelector(selectLoginDomain, (state: LoginState) => state[key]);

export const loginSelectors = {
  data: makeSelectLogin('data'),
  loading: makeSelectLogin('loading'),
  error: makeSelectLogin('error'),
  user: makeSelectLogin('user'),
  isAuthenticated: makeSelectLogin('isAuthenticated'),
  token: makeSelectLogin('token'),
};
